// extracted by mini-css-extract-plugin
module.exports = {"wrap":"da51a739f7--wrap--rzCGx","tabs":"da51a739f7--tabs--eISRl"};